export default __webpack_public_path__ + "static/4-65e877e527022735c1a1bf5ae6183cf6.woff2";